import { replacerCostIfValue } from 'utils/replacerCost';

export type convertCheckedHelperArgsType = {
    checkedIds: {
        [key: number | string]: {
            parent: string | boolean;
            value?: string;
            [key: string]: boolean | string | undefined;
        };
    };
};

type TObjListType = {
    workOrderChangeObjectId: number | null;
    workOrderObjectId: number | null;
};

type TOtherPricesType = {
    contractOtherCostId: number;
    includedCost: number | null;
    objectIdList: TObjListType[];
}[];

const toNumberOrNull = (value: string) => (value ? Number(value) : null);

export const convertCheckedHelper = ({ checkedIds }: convertCheckedHelperArgsType) =>
    Object.entries(checkedIds).reduce((acc: TOtherPricesType, [contractOtherCostId, otherObjectValues]) => {
        if (!otherObjectValues.parent) {
            return acc;
        }

        const contractOtherCostIdNumber = Number(contractOtherCostId);
        const includedCost = replacerCostIfValue(otherObjectValues.value);

        const objList = Object.entries(otherObjectValues).reduce((objListAcc: TObjListType[], [objKey, objValue]) => {
            if (objValue && objKey !== 'parent' && objKey !== 'value') {
                // note: objKey это пара `${object.workOrderObjectId}_${object.workOrderChangeObjectId}`,
                const [workOrderObjectId, workOrderChangeObjectId] = objKey.split('_');

                if (workOrderObjectId || workOrderChangeObjectId) {
                    objListAcc.push({
                        workOrderChangeObjectId: toNumberOrNull(workOrderChangeObjectId),
                        workOrderObjectId: toNumberOrNull(workOrderObjectId),
                    });
                }
            }

            return objListAcc;
        }, []);

        acc.push({
            contractOtherCostId: contractOtherCostIdNumber,
            includedCost,
            objectIdList: objList,
        });

        return acc;
    }, []);
